class CartRecsSlider extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));

    queueMicrotask(() => this.updateArrows());

    const list = this.querySelector('.cart-recs__list');
    if (list) {
      list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    }

    this.resizeHandler = () => this.updateArrows();
    window.addEventListener('resize', this.resizeHandler, { passive: true });

    // Re-check arrows after the inner product cards finish loading (API fills them in)
    const productRecs = this.querySelector('product-recommendations');
    if (productRecs) {
      this.mutationObserver = new MutationObserver(() => {
        const newList = this.querySelector('.cart-recs__list');
        if (newList && !newList.dataset.scrollAttached) {
          newList.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          newList.dataset.scrollAttached = 'true';
        }
        this.updateArrows();
      });
      this.mutationObserver.observe(productRecs, { childList: true, subtree: false });
    }
  }

  disconnectedCallback() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  handleClick(event) {
    if (event.target.closest('.cart-recs__prev')) {
      event.preventDefault();
      this.scrollByCard(-1);
    } else if (event.target.closest('.cart-recs__next')) {
      event.preventDefault();
      this.scrollByCard(1);
    }
  }

  scrollByCard(direction) {
    const list = this.querySelector('.cart-recs__list');
    if (!list) return;

    const firstItem = list.querySelector('.cart-recs__item');
    if (!firstItem) return;

    const gap = parseInt(getComputedStyle(list).columnGap || getComputedStyle(list).gap, 10) || 24;
    const distance = (firstItem.offsetWidth + gap) * direction;

    list.scrollBy({ left: distance, behavior: 'smooth' });
  }

  updateArrows() {
    const list = this.querySelector('.cart-recs__list');
    const arrowsWrapper = this.querySelector('.cart-recs__arrows');
    if (!arrowsWrapper) return;

    if (!list) {
      arrowsWrapper.hidden = true;
      return;
    }

    const hasOverflow = list.scrollWidth > list.clientWidth + 1;
    arrowsWrapper.hidden = !hasOverflow;

    if (!hasOverflow) return;

    const prev = this.querySelector('.cart-recs__prev');
    const next = this.querySelector('.cart-recs__next');
    const max = list.scrollWidth - list.clientWidth - 1;
    if (prev) prev.disabled = list.scrollLeft <= 0;
    if (next) next.disabled = list.scrollLeft >= max;
  }
}

if (!customElements.get('cart-recs-slider')) {
  customElements.define('cart-recs-slider', CartRecsSlider);
}
